import React, { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  direction?: 'center' | 'bottom';
  overlayClassName?: string;
  contentClassName?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
  direction = 'center',
  overlayClassName,
  contentClassName,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'; // Disable scrolling
    } else {
      document.body.style.overflow = ''; // Re-enable scrolling
    }

    return () => {
      document.body.style.overflow = ''; // Cleanup when modal unmounts
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const overlayTone = overlayClassName ?? 'bg-gray-300 bg-opacity-75';

  const contentPadding = contentClassName ?? 'p-6';

  const centerShellClass =
    direction === 'bottom'
      ? 'rounded-t-3xl w-full motion-safe:animate-[slideUp_0.3s_ease-out]'
      : 'mx-4 max-w-full';

  const defaultCenterChrome =
    direction === 'bottom'
      ? 'bg-white shadow-lg'
      : 'rounded-3xl bg-white shadow-lg';

  const innerClassName = [
    'z-50',
    centerShellClass,
    contentClassName !== undefined
      ? contentPadding
      : `${defaultCenterChrome} ${contentPadding}`,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={`fixed inset-0 ${overlayTone} flex justify-center z-50 ${
        direction === 'bottom' ? 'items-end px-0' : 'items-center px-4'
      }  ${className ? className : ''}`}
      onClick={onClose}
    >
      <div className={innerClassName} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
